import { createFileRoute } from '@tanstack/react-router'

import { PlatformAdminTimePage } from '../../../../components/pages/backoffice/platform/platform-time-admin-page/platform-admin-time-page.tsx'
import { PermissionChecker } from '../../../../components/templates/permission-checker.tsx'

export const Route = createFileRoute('/bo/admin/time')({
  component: () => (
    <PermissionChecker requiredPermissions={['tech.configurations']}>
      <PlatformAdminTimePage />
    </PermissionChecker>
  ),
})
